import type { ModalEntries } from '@vnetwork/datacentral-shell/host'

// The module's modals, registered with the host by createBusinessModule (#212).
// require.context cannot see packages/, so they are declared here, one entry
// per modal, under the keys setModal('<Group>/<Modal>/index') has always used.
// check:modal-keys reads this file: keep every entry as
// '<key>': () => import('<relative path>').
export const businessModals = {
    'BusinessModals/BusinessApprovalModal/index': () =>
        import('./modals/BusinessModals/BusinessApprovalModal'),
    'BusinessModals/Cancelled/index': () =>
        import('./modals/BusinessModals/Cancelled'),
} satisfies ModalEntries
